<div class="share-information">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 my-md-5 mb-5 sec-title">
                <app-title-page [dataTitle]="dataTitle" [link]="'#share-doc'"></app-title-page>
            </div>
            <!-- documents -->
            <div class="col-md-12 documents" id="share-doc">
                <div class="lane-top">
                    <div class="row mt-5">
                        <!-- Share Performance -->
                        <div class="col-md-12">
                            <h3 class="f-subtit">{{ dataSection[0]?.title }}</h3>
                            <h5 class="info mt-4">PT Sampoerna Agro Tbk (SGRO.JK)</h5>
                            <div [innerHTML]="dataSection[0]?.content" class="mb-3 mt-2"></div>
                            <img [src]="apiAsset + dataSection[0]?.picture" class="w-100" alt="">
                            <h5 class="info my-4">{{ dataSection[1]?.title }}</h5>
                            <div class="table-finance" [innerHTML]="dataSection[1]?.content"></div> 
                        </div>
                        <!-- Sharelisting Chronology -->
                        <div class="col-md-12 mt-5">
                            <h3 class="f-subtit">{{ dataSection[2]?.title }}</h3>
                            <div class="row">
                                <div class="col-md-11 mx-auto mt-4">
                                    <div class="table-share" [innerHTML]="dataSection[2]?.content"></div>
                                </div>
                            </div>
                        </div>
                        <!-- Shareholders Composition -->
                        <div class="col-md-12 mt-5">
                            <h3 class="f-subtit">{{ dataSection[3]?.title }}</h3>
                            <div class="content">
                                <!--<div class="my-4">
                                    <p>{{ isLang?.totalShares }}: {{ dataChartTotal | number }}</p>
                                    <p>Per {{ dataChartDate }}</p> 
                                </div>
                                <div class="chartdiv">
                                    <canvas id="myChart"></canvas>
                                </div>-->
                                <div class="pict mt-4 px-md-5">
                                    <img [src]="apiAsset + dataSection[3]?.picture" class="w-100" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div>
